import { FragmentAnalysis } from "./fragment-analysis";

export class FAWorkFileGenerationRequest {
    faRequest: FragmentAnalysis[];
    barcodeMeasurementIdMap: any;
    userId: string;
    workfileName: string;
    labId: string;
}